import { createElement as _createElement } from "react";
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Autocomplete as MuiAutocomplete, } from '@mui/material';
import { equals } from 'ramda';
import React, { useCallback, } from 'react';
import { styled } from '../../utils';
import { Icon } from '../Icon';
import { TextField } from '../TextField';
// TODO: support null as value to be consistent with other fields
function AutocompleteInternal({ highlightedOptions, ...props }, ref) {
    const { TextFieldProps, disableOnChange = () => false, classes, label, helperText, error, required, hasValue, getOptionLabel, renderOption, placeholder, startAdornment, endAdornment, ...otherProps } = props;
    const renderInput = useCallback((params) => {
        return (_jsx(TextField, { ...params, label: label && label + (required ? '\xa0*' : ''), helperText: helperText, error: error, placeholder: placeholder, disabled: props.disabled || props.externalLoading, loading: props.externalLoading, inputProps: {
                ...params.inputProps,
                onChange: (e) => {
                    if (!disableOnChange(e) && params.inputProps?.onChange)
                        params.inputProps.onChange(e);
                },
                autoComplete: 'no', // disables chrome autocomplete
            }, hasValue: typeof props.value === 'object' || Array.isArray(props.value)
                ? hasValue
                : !!props.value, InputProps: {
                ...params.InputProps,
                ...(startAdornment &&
                    !props.multiple && {
                    startAdornment,
                }),
                ...(endAdornment && !props.multiple && { endAdornment }),
            }, ...TextFieldProps }));
    }, [
        label,
        placeholder,
        props.disabled,
        props.externalLoading,
        props.multiple,
        required,
        helperText,
        error,
        props.value,
        hasValue,
        startAdornment,
        endAdornment,
        TextFieldProps,
        disableOnChange,
    ]);
    const defaultRenderOption = ({ className, children: _children, ...props }, option, _state) => {
        if (highlightedOptions?.some((item) => equals(item, option))) {
            return (_jsx(DefaultRenderOptionStyled, { ...props, className: className, children: _jsxs(_Fragment, { children: [getOptionLabel ? getOptionLabel(option) : option, _jsx(HighlightedIconStyled, { variant: "star" })] }) }));
        }
        // TODO: This would be faster if we can pass a numeric index
        return (_createElement("li", { ...props, className: className, key: `${JSON.stringify(option)}` },
            _jsx(_Fragment, { children: getOptionLabel ? getOptionLabel(option) : option })));
    };
    return (_jsx(AutocompleteStyled, { ...otherProps, disabled: props.disabled || props.externalLoading, popupIcon: props.disabled ? null : _jsx(Icon, { variant: "arrow-down-2" }), classes: classes, renderInput: renderInput, getOptionLabel: getOptionLabel, renderOption: renderOption ? renderOption : defaultRenderOption, ref: ref }));
}
const AutocompleteStyled = styled(MuiAutocomplete, {
    shouldForwardProp: (prop) => prop !== 'externalLoading',
})(({ theme, externalLoading }) => ({
    //TODO: improve with new design system to not need overflow hidden (needed for overflowing CircleLoader)
    overflow: 'hidden',
    ...(externalLoading && {
        '&.MuiAutocomplete-hasPopupIcon.MuiAutocomplete-root .MuiAutocomplete-inputRoot': {
            paddingRight: 0,
        },
    }),
    '& .MuiAutocomplete-popupIndicator': {
        '& .MuiIcon-root': { fontSize: theme.typography.body2.fontSize },
    },
    '& .MuiAutocomplete-paper': {
        borderRadius: theme.spacing(0.5),
    },
    '& 	.MuiAutocomplete-option': {
        '&[data-focus=true]': {
            backgroundColor: theme.palette.secondary.contrastText,
        },
        '&[aria-selected=true]': {
            backgroundColor: theme.palette.groupPrimary.lightDove,
        },
    },
}));
const DefaultRenderOptionStyled = styled('li')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    fontWeight: theme.typography.fontWeightMedium,
}));
const HighlightedIconStyled = styled(Icon)(({ theme }) => ({
    color: theme.palette.primary.dark,
    fontSize: '0.9rem',
    marginLeft: '0.2rem',
    marginBottom: '0.1rem',
    verticalAlign: 'middle',
}));
export const Autocomplete = React.forwardRef(AutocompleteInternal);
